import { render, staticRenderFns } from "./added-to-cart-modal-product.vue?vue&type=template&id=f96638bc&"
import script from "./added-to-cart-modal-product.vue.ts?vue&type=script&lang=ts&"
export * from "./added-to-cart-modal-product.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports